import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const HomeSelected = (props: SvgProps) => {
  const { color } = props
  return (
    <Svg fill='none' height='26' viewBox='0 0 24 26' width='24' {...props}>
      <Path
        d='m22.4678 24.08 1.5122-13.8689c.1137-1.04324-.3259-2.07003-1.1592-2.70773l-8.9989-6.885877c-1.0759-.823323-2.5702-.823324-3.6461-.000001l-8.99885 6.885878c-.83338.6377-1.2729797 1.66449-1.1592376 2.70773l1.5113476 13.8613c.05532.5073.48378.8916.99411.8916h5.47148c.55228 0 1-.4477 1-1v-7.4229c0-.5523.44771-1 1-1h3.99995c.5523 0 1 .4477 1 1v7.4768c0 .5556.4529 1.0047 1.0085 1l5.4791-.0463c.5071-.0043.9307-.3875.9856-.8916z'
        fill={color}
      />
    </Svg>
  )
}
